export const environment = {
  production: false,
  enablePfeuCreditApplicationReport: true,
  azureAd: {
    clientId: '1774c04b-9b68-4b3f-964a-1084428a9c34',
    authority: 'https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1',
    redirectUrl: 'https://ccubepat.rabo.cloud',
    posLogoutUrl: 'https://ccubepat.rabo.cloud',
  },
  scopes: ['GroupMember.Read.All','User.Read'],
  // Admin group id (users in this group see all applications)
  adminGroupId: '1c47f8cf-6174-4983-ab19-efea1e19aadd',
  connectorGroupMap: {
    AG_DESK: ['5a84b9fc-9bc6-438f-91bb-3e2f856c8565'],
    PFEU: ['ec5a0389-695c-4a8b-8ca8-dd7801891389'],
    VCF: ['2a7fb94c-b5a6-45b6-a99a-f1f8c9acca29']
  },
  
  apiBaseUrl: 'https://ccubepat.rabo.cloud/api/v1',
  resourceBatches: function() {
    return `api://${this.azureAd.clientId}/batches`;
  }
};
